export enum WakeLockStatus {
  Disabled = 'Disabled',
  Temporary = 'Temporary',
  UntilResponse = 'UntilResponse',
}
